import React from 'react'
import './Home.css'
import withLayout from '../../withLayout'
import GroupsContext from '../../GroupsContext'
import Cover from '../commons/Cover'
import coverImg from '../../images/background_welcome.jpg'
import coverImgEmpty from '../../images/background_empty.jpg'
import { ActionBtn } from '../commons/Actions'
import ListGroups from '../modules/ListGroups'

const Home = (props) =>
  <GroupsContext.Consumer>
    {(groups) => {
      if (groups.length > 0) {
        return (
          <div className='home'>
            <div className='home__desktop'>
              <Cover title='Bienvenido' image={coverImg} />
              <div className='home__instruction'>
                <p>Selecciona, crea o únete a un grupo para comenzar.</p>
                <p>Al lado izquierdo se encuentran los grupos en los que estás participando.</p>
              </div>
            </div>
            <div className='home__mobile'>
              <ListGroups groups={groups} />
            </div>
          </div>
        )
      }
      return (
        <div className='home home--empty'>
          <Cover title='¿Sin quinielas?' image={coverImgEmpty} />
          <div className='home__action'>
            <ActionBtn icon='group_add' onClick={() => props.handleModal('createGroup')} />
            <p>Crea un grupo y agrega a tus “aprendices”</p>
          </div>
          <div className='home__action'>
            <ActionBtn icon='star' onClick={() => props.handleModal('enterGroup')} />
            <p>Tengo un código para quiniela <b>premium</b></p>
          </div>
        </div>
      )
    }}
  </GroupsContext.Consumer>

export default withLayout(Home, true)
